<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ysW3fd/tc-custom/CoverDesign.jpg?1684514558450?1728851724838" alt="This image is the cover for the book Amors Pfeile, Verliebte Anwälte"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Amors Pfeile, Verliebte Anwälte
      </h1>
      <p class="bookDescription body article font2">
        <p>Die erfolgreichen Anwälte Dane Coulter und Cal Monroe sind Rivalen im Gerichtssaal und Freunde hinter den Kulissen. Doch können sie mehr sein?</p><p>Cal hat immer heimlich nach Dane geschmachtet. Allerdings verdrängt Dane seine Homosexualität so sehr, dass er nicht mal zugeben kann, dass er möglicherweise schwul ist. Sein Vater, ein fanatischer Homophober, regiert die Familie mit eiserner Hand und drängt Dane zu einer Verlobung – mit einer Frau. Um seine Mutter zu schützen, stimmt Dane zu. Für Cal bringt die Sache jedoch das Fass zum Überlaufen.</p><p>Er kann nicht zulassen, dass Dane einen Fehler macht, der sein gesamtes restliches Leben ruiniert und kennt nur einen todsicheren Weg, damit Dane sich eingesteht, wie es in seinem Herzen aussieht. Seinem Freund seine Gefühle zu offenbaren, könnte jedoch nach hinten losgehen und einen Keil zwischen sie treiben. Und selbst dann ist es Dane, der die Entscheidung treffen muss: Das Leben zu leben, das sein Vater von ihm erwartet oder alles, was er hat, für die Chance auf Glück in Cals Armen aufzugeben.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ari McKay, Nora Lys
      </h2>
      
      <p class="authorDescription body article"><P>Ari McKay is the professional pseudonym for Arionrhod and McKay, who have been writing together for over a decade. Their collaborations encompass a wide variety of romance genres, including contemporary, fantasy, science fiction, gothic, and action/adventure. Their work includes the Blood Bathory series of paranormal novels, the Herc&rsquo;s Mercs series, as well as two historical Westerns: <I>Heart of Stone</I> and <I>Finding Forgiveness</I>. When not writing, they can often be found scheming over costume designs or binge watching TV shows together.<BR /><BR />Arionrhod is a systems engineer by day who is eagerly looking forward to (hopefully) becoming a full-time writer in the not-too-distant future. Now that she is an empty-nester, she has turned her attentions to finding the perfect piece of land to build a fortress in preparation for the zombie apocalypse, and baking (and eating) far too many cakes.<BR /><BR />McKay is an English teacher who has been writing for one reason or another most of her life. She also enjoys knitting, reading, cooking, and playing video games. She has been known to knit in public. Given she has the survival skills of a gnat, she&rsquo;s relying on Arionrhod to help her survive the zombie apocalypse.</P><P>Visit Ari on:</P><P>Website: arimckay.com</P><P>Facebook: www.facebook.com/pages/Ari-Mckay/266185570179748</P><P>Twitter: @AriMcKay1</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Dreamspinner Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?838b0658